import gsap from 'gsap'
import { BUILDING_TYPES } from '../Game/definitions.js'
import { createTextSprite } from './InteractionTile.js'

export default class BuildingView
{
    constructor(_options)
    {
        this.building = _options.building
        this.factory = _options.factory
        this.container = this.factory.createBuilding(this.building.type)
        this.container.position.set(this.building.x, this.building.y, 0)
        this.container.scale.setScalar(0.01)
        this.lastStackKey = ''
        const label = createTextSprite(BUILDING_TYPES[this.building.type].label.toUpperCase(), { background: 'rgba(20, 15, 31, 0.88)', color: '#c8ffdb' })
        label.position.set(0, 0, 3.1)
        label.scale.set(3.5, 0.72, 1)
        this.container.add(label)
        gsap.to(this.container.scale, { x: 1, y: 1, z: 1, duration: 0.7, ease: 'back.out(1.7)' })
        this.sync()
    }

    clearStack(_anchor)
    {
        for(const child of [..._anchor.children])
        {
            child.traverse((_child) =>
            {
                if(_child.isMesh)
                    _child.geometry.dispose()
            })
            _anchor.remove(child)
        }
    }

    fillStack(_anchor, _entries)
    {
        this.clearStack(_anchor)
        let index = 0
        for(const [resource, count] of _entries)
        {
            for(let itemIndex = 0; itemIndex < count; itemIndex++)
            {
                const item = this.factory.createItem(resource, 0.9)
                item.position.set((index % 3 - 1) * 0.3, (Math.floor(index / 3) % 3 - 1) * 0.28, Math.floor(index / 9) * 0.18)
                item.rotation.z = (index % 2 ? 1 : -1) * 0.12
                _anchor.add(item)
                index++
            }
        }
    }

    sync()
    {
        const definition = BUILDING_TYPES[this.building.type]
        const key = JSON.stringify([this.building.inputs, this.building.output, this.building.raisingType])
        if(key === this.lastStackKey)
            return
        this.lastStackKey = key
        const inputs = Object.entries(this.building.inputs).filter(([resource]) => resource !== 'souls' && resource !== 'deadwood')
        const fuel = Object.entries(this.building.inputs).filter(([resource]) => resource === 'souls' || resource === 'deadwood')
        this.fillStack(this.container.userData.input, inputs)
        this.fillStack(this.container.userData.fuel, fuel)
        this.fillStack(this.container.userData.output, definition.output ? [[definition.output, this.building.output]] : [])
    }

    update(_elapsed)
    {
        const parts = this.container.userData
        const definition = BUILDING_TYPES[this.building.type]
        if(parts.fuelStatus)
        {
            const fuelCount = (this.building.inputs.souls ?? 0) + (this.building.inputs.deadwood ?? 0)
            parts.fuelStatus.visible = Boolean(definition.fuel) && fuelCount === 0 && this.building.fuelRemaining < 2
            parts.fuelStatus.position.z = 3 + Math.sin(_elapsed * 0.006) * 0.16
            parts.exclamationMaterial.opacity = 0.5 + (Math.sin(_elapsed * 0.012) * 0.5 + 0.5) * 0.5
        }
        parts.fire.visible = this.building.active
        parts.smoke.visible = this.building.active
        parts.movingPart.rotation.z += this.building.active ? 0.018 : 0.004
        parts.movingPart.position.z = (definition.kind === 'crypt' ? 2.15 : 1.2) + Math.sin(_elapsed * 0.004) * 0.1
        if(this.building.active)
        {
            parts.fire.scale.setScalar(0.9 + Math.sin(_elapsed * 0.018) * 0.16)
            for(const puff of parts.smoke.children)
            {
                const phase = (_elapsed * 0.0007 + puff.userData.offset) % 2
                puff.position.z = 1.8 + phase * 0.65
                puff.material.opacity = (1 - phase / 2) * 0.32
            }
        }
        this.sync()
    }
}
